import { apiEmployees } from "@/api/employees/employee.api";
import {
  ApiEmployeeChartFilter,
  ApiEmployeeChartItem,
  EmployeeNodeMode,
} from "@/pages/employees/chart/employees-chart.types.ts";

export default function UseEmployeesChartHook() {
  const loadEmployees = async (
    employeeId: number | undefined,
    filter: ApiEmployeeChartFilter,
    mode: EmployeeNodeMode = EmployeeNodeMode.children
  ) => {
    const { data: employees } = await apiEmployees.chart(employeeId, mode, filter);

    return employees;
  };

  const loadEmployee = async (employeeId: number | string) => {
    const { data: employee } = await apiEmployees.getById(employeeId);

    return employee;
  };

  const loadEmployeesChartByNodeId = async (
    nodeId: string | undefined,
    filter: ApiEmployeeChartFilter,
    mode: EmployeeNodeMode = EmployeeNodeMode.children
  ): Promise<ApiEmployeeChartItem[]> => {
    if (!nodeId) return [];
    if (nodeId == "root") return [];

    const id = Number(nodeId);
    const employees = await loadEmployees(id, filter, mode);

    return employees ?? [];
  };

  return {
    loadEmployees,
    loadEmployee,
    loadEmployeesChartByNodeId,
  };
}
